import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Customer.css';

interface CreditEntry {
    id: number;
    amount: number;
    type: string;
    reason: string;
    referenceId: number;
    date: string;
}

const CustomerCredits: React.FC = () => {
    const [balance, setBalance] = useState<number>(0);
    const [ledger, setLedger] = useState<CreditEntry[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCredits();
    }, []);

    const fetchCredits = async () => {
        try {
            const [balanceRes, ledgerRes] = await Promise.all([
                axios.get('/api/credit/user/balance'),
                axios.get('/api/credit/user/ledger')
            ]);
            setBalance(balanceRes.data.balance);
            setLedger(ledgerRes.data.ledger);
        } catch (error) {
            console.error('Failed to fetch credits:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="loading">Loading...</div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container">
                <h1 className="page-title">💰 My Credits</h1>

                <div className="card">
                    <h2>Current Balance</h2>
                    <p className="stat-value" style={{ fontSize: '2rem', color: balance >= 0 ? '#28a745' : '#dc3545' }}>
                        {balance} credits
                    </p>
                </div>

                <div className="card">
                    <h2>Transaction History</h2>
                    <div className="table-container">
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Type</th>
                                    <th>Reason</th>
                                    <th>Ref ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ledger.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: 'center' }}>
                                            No credit transactions yet
                                        </td>
                                    </tr>
                                ) : (
                                    ledger.map((entry) => (
                                        <tr key={entry.id}>
                                            <td>{new Date(entry.date).toLocaleString()}</td>
                                            <td style={{ color: entry.amount > 0 ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>
                                                {entry.amount > 0 ? '+' : ''}{entry.amount}
                                            </td>
                                            <td>{entry.type}</td>
                                            <td>{entry.reason.replace('_', ' ')}</td>
                                            <td>{entry.referenceId}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerCredits;
